import Axios, { AxiosError } from "axios";
import * as Sentry from "@sentry/react";

const Api = Axios.create({
  baseURL: process.env.BASE_API_URL,
  timeout: 20000
});

const handleRequest = (request: any) => {
  const cookieValue = (name: string) => {
    const cookie = document?.cookie
      ?.split("; ")
      ?.find((row) => row.startsWith(`${name}=`))
      ?.split("=")[1];

    return cookie;
  };

  const authCookie = cookieValue("VtexIdclientAutCookie_cobasi")?.replace(
    /"/g,
    ""
  );
  const cobasiSession = cookieValue("cobasiSession");
  const checkoutdataaccess = cookieValue("checkoutdataaccess");

  if (authCookie) {
    request.headers["Authorization"] = authCookie;
  }

  if (checkoutdataaccess) {
    request.headers["checkoutdataaccess"] = checkoutdataaccess;
  }

  if (cobasiSession) {
    request.headers["X-Cobasi-Session"] = cobasiSession;
  }

  return request;
};

const handleUnauthorizedRequest = (error: AxiosError) => {
  Sentry.captureException(error);
  return Promise.reject(error);
};

Api.interceptors.request.use(
  (request) => handleRequest(request),
  (error) => Promise.reject(error)
);

Api.interceptors.response.use(
  (response) => response,
  (error) => handleUnauthorizedRequest(error)
);

export default Api;
